import React from "react";
import { Popover, Box } from "@mui/material";
import { CompactPicker } from "react-color";
import ClickAwayListener from "@mui/base/ClickAwayListener";

export default function PlanFormColorSelect(props) {
  const handleInputChange = props.handleInputChange;
  const [planColor, setPlanColor] = React.useState(props.defaultColor);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const colorOpen = Boolean(anchorEl);

  function handleChangeComplete(c) {
    setPlanColor(c.hex);
    setAnchorEl(null);
  }

  const handleColorClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleColorClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        backgroundColor: planColor,
        width: "100%",
        height: "48px",
        "&:hover": { opacity: 0.8, transition: ".2s" },
      }}
      onClick={handleColorClick}
    >
      <Popover
        id={`plan-color-picker`}
        open={colorOpen}
        anchorEl={anchorEl}
        onClose={handleColorClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{ marginLeft: "24px", boxShadow: 1 }}
      >
        <ClickAwayListener onClickAway={handleColorClose}>
          <CompactPicker
            onChangeComplete={(e) => {
              handleChangeComplete(e);
              handleInputChange({ name: "color", value: e.hex });
            }}
          />
        </ClickAwayListener>
      </Popover>
    </Box>
  );
}
